import React from 'react';
import { Col } from 'reactstrap';
import { Chip, ChipColor } from '../../../../../components/Chip';
import { SigningLink } from '../../../../../entities/v1/applicant_tracking/SigningLink';

interface PropTypes {
  candidateName: string;
  offerStatus: string;
  signableOfferSignatories: SigningLink[];
}

function SignatoryStatusChip(props: { status: string }) {
  switch (props.status) {
    case 'pending':
      return (
        <Chip size='sm' color={ChipColor.OrangeLight}>
          Pending
        </Chip>
      );
    case 'signed':
      return (
        <Chip size='sm' color={ChipColor.SuccessLight}>
          Signed
        </Chip>
      );
    case 'declined':
      return (
        <Chip size='sm' color={ChipColor.DangerLight}>
          Declined
        </Chip>
      );
  }
}

function SignatoryRow(props: {
  offerStatus: string;
  name: string;
  status: string;
}) {
  return (
    <div className='d-flex justify-content-between mt-2'>
      <Col className='fs-5' xs='10'>
        {props.name}
      </Col>
      <Col className='fs-5' xs='auto'>
        <SignatoryStatusChip status={props.status} />
      </Col>
    </div>
  );
}

export function SignableOfferSignatories(props: PropTypes) {
  return (
    props.signableOfferSignatories?.length > 0 && (
      <div>
        <div className='d-flex justify-content-between'>
          <Col className='fs-5' xs='10'>
            Signatories
          </Col>
          <Col className='fs-5 me-auto' xs='auto'>
            Status
          </Col>
        </div>
        {props.signableOfferSignatories.map((signatory, index) => {
          return (
            <SignatoryRow
              key={index}
              offerStatus={props.offerStatus}
              name={
                signatory.userId != null
                  ? signatory.user.name
                  : props.candidateName
              }
              status={signatory.status}
            />
          );
        })}
      </div>
    )
  );
}
